import { TransactionResultStatus } from '~core/models/payment.models';

export const getTransactionStatusName = (
  value: TransactionResultStatus | undefined | null
): string => {
  if (!value) {
    return '';
  }

  switch (value) {
    case 'pending':
      return 'En attente';

    case 'failed':
      return 'Échoué';

    case 'completed':
      return 'Terminé';

    case 'refused':
      return 'Refusé';

    case 'processing':
      return 'En cours';

    case 'reversed':
      return 'Inversé';

    case 'canceled':
      return 'Annulé';

    case 'accepted':
      return 'Accepté';

    case 'unknown':
      return 'Inconnu';

    case 'expired':
      return 'Expiré';

    default:
      return value;
  }
};
